import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import './LoginMessages.scss';

export const LoginMessages = () => {
  const selectedMessages = useSelector((state) => state.resources.login_messages?.data);

  // Use useMemo to return the same empty array if messages doesn't exist
  const messages = useMemo(() => selectedMessages || [], [selectedMessages]);

  return (
    <div className="login-messages">
      <div className="row">
        <div className="col-2" />
        <div className="col-8">
          {Boolean(messages.length) &&
            messages.map((item) => (
              <div className="login-messages__item" key={item.id}>
                <h2 className="heading heading--bold heading--color-white heading--subsection">{item.title}</h2>
                <p className="copy copy--color-white">{item.description}</p>
              </div>
            ))}
        </div>
        <div className="col-2" />
      </div>
    </div>
  );
};

export default LoginMessages;
